module.exports = __webpack_public_path__ + "static/the-book-of-awakening-f13a5c0511bdd9b05329b66d6d92fc64.jpg";